import React, { Component } from 'react';

// import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
// import ImagePanel from '@components/ImagePanel/ImagePanel';
// import TextBox from '@components/TextBox/TextBox';
// import CloudPanel from '@components/CloudPanel/CloudPanel';
// import { Container, Row, Col } from 'reactstrap';
// import List from './List/List';
// import ListMobile from './ListMobile/ListMobile';

// const Image = ImportImages('/suitedeals/suitedeals.jpg');
// import { homeData, firstTimeData, bookSuiteDealData } from './suitedeals-data';

class Suitedeals extends Component {
  constructor(props) {
    super(props);
    window.location.href = 'https://account.jetsuite.com/suitedeal';
  }
  render = () => {
    /* const containerProps = {
      pageHeight: this.props.pageHeight
    }; */
    return (
      <div>Redirecting...</div>
      /* <ScrollContainer {...containerProps}>
        <ImagePanel
          id={'suitedeals-imagepanel'}
          screenHeight={this.props.pageHeight}
          image={Image}
          alt={'Compare Aircraft'}
          jsiClass={'d-none d-md-block'}
        >
          <div className={'abs-container d-flex align-items-center'}>
            <Container>
              <Row>
                <Col xs={12} md={{ size: 5, offset: 7 }}>
                  <TextBox {...homeData} />
                </Col>
              </Row>
            </Container>
          </div>
        </ImagePanel>

        {this.props.pageWidth > 991 ? (
          <CloudPanel
            id={'suitedeals-list-cloudpanel'}
            hideJSILogo={true}
            screenHeight={this.props.pageHeight}
          >
            <List />
          </CloudPanel>
        ) : (
          <ListMobile id={'suitedeals-list-mobile'} />
        )}

        <CloudPanel
          id={'suitedeals-first-time'}
          screenHeight={this.props.pageHeight}
        >
          <div className={'abs-container d-flex align-items-center'}>
            <Container>
              <Row>
                <Col xs={12} md={{ size: 7, offset: 5 }}>
                  <TextBox {...firstTimeData} />
                </Col>
              </Row>
            </Container>
          </div>
        </CloudPanel>

        <CloudPanel id={'suitedeals-book'} screenHeight={this.props.pageHeight}>
          <div className={'abs-container d-flex align-items-center'}>
            <Container>
              <Row>
                <Col xs={12} md={{ size: 7, offset: 5 }}>
                  <TextBox {...bookSuiteDealData} />
                </Col>
              </Row>
            </Container>
          </div>
        </CloudPanel>
      </ScrollContainer> */
    );
  };
}

export default Suitedeals;



// WEBPACK FOOTER //
// ./src/components/Suitedeals/Suitedeals.jsx